import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetRotationsInputDto, RotationCreateDto, RotationDto, RotationExcelDownloadDto, RotationUpdateDto } from '../dtos/rotation/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class RotationService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: RotationCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RotationDto>({
      method: 'POST',
      url: '/api/geographic/rotations',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/rotations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/rotations',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RotationDto>({
      method: 'GET',
      url: `/api/geographic/rotations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/rotations/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetRotationsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<RotationDto>>({
      method: 'GET',
      url: '/api/geographic/rotations',
      params: { cycleId: input.cycleId, cycleValue: input.cycleValue, rotationValue: input.rotationValue, rotationValueFrom: input.rotationValueFrom, rotationValueTo: input.rotationValueTo, rotationDate: input.rotationDate, rotationDateFrom: input.rotationDateFrom, rotationDateTo: input.rotationDateTo, rotationArea: input.rotationArea, rotationAreaFrom: input.rotationAreaFrom, rotationAreaTo: input.rotationAreaTo, rotationUseId: input.rotationUseId, rotationPurposeId: input.rotationPurposeId, isLastRotation: input.isLastRotation, isCupClosed: input.isCupClosed, forestryStatusId: input.forestryStatusId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: RotationExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/rotations/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, cycleId: input.cycleId, cycleValue: input.cycleValue, rotationValue: input.rotationValue, rotationValueFrom: input.rotationValueFrom, rotationValueTo: input.rotationValueTo, rotationDate: input.rotationDate, rotationDateFrom: input.rotationDateFrom, rotationDateTo: input.rotationDateTo, rotationArea: input.rotationArea, rotationAreaFrom: input.rotationAreaFrom, rotationAreaTo: input.rotationAreaTo, rotationUseId: input.rotationUseId, rotationPurposeId: input.rotationPurposeId, isLastRotation: input.isLastRotation, isCupClosed: input.isCupClosed, forestryStatusId: input.forestryStatusId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RotationDto[]>({
      method: 'GET',
      url: '/api/geographic/rotations/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  undoDelete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RotationDto>({
      method: 'POST',
      url: `/api/geographic/rotations/${id}/undo-delete`,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: RotationUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RotationDto>({
      method: 'PUT',
      url: `/api/geographic/rotations/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}